var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "6px",
    viewBox: "0 0 20 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-30",
    transform: "translate(-206.000000, -77.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9117604,34.3181483 L50.070225,34.3181483 C47.4854761,37.6857187 44.4035176,39.6707686 40.8243494,40.273298 C37.3152628,39.7242829 35.0472565,38.8039815 34.0203306,37.5123937 L30.9117604,34.3181483 Z",
    id: "Chin"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChin);
export default __webpack_public_path__ + "static/media/Chin.2b10c32f89f0bb9d4fa0ab156a7e6f31.svg";
export { ForwardRef as ReactComponent };